{
  "remove": "Видалити"
}
